export const formData = state => state.formData;
export const formName = state => state.formName;
